import config from '../config'
import axios from 'axios'
import store from '../store'
import { toast } from 'react-toastify'
import {redirectToLogin} from './redirect'

var headers = {'Content-Type': 'application/json; charset=UTF-8', 'Cache-Control': "no-cache",};

var instance = axios.create({
    baseURL: config.serverUrl,
    headers
});

const loading = (type) => {
  if(type === 'start'){
    store.dispatch({"type":"ADD_LOADING", payload:{} })
  }else if(type === 'stop'){
    store.dispatch({"type":"REMOVE_LOADING", payload:{} })
  }
}

const serviceInit = () => {
    var appData = JSON.parse(localStorage.getItem('appData')) || {};
    if(!instance.defaults.headers.common['Access-Token'] && appData.access_token){
      instance.defaults.headers['Access-Token'] = appData.access_token
    }else{

    }
}

const errorHandler = (err={}, load=true, notif=true, scallback = ()=>{}, ecallback = ()=>{}, reqData={}) => {

  if(!err.response){err.response={status:''}}
  switch (err.response.status) {
    case 401:
      var appData = JSON.parse(localStorage.getItem('appData')) || {};

      if( appData.access_token && appData.refresh_token){
        var refreshTokenData = { 'access_token': appData.access_token, 'refresh_token': appData.refresh_token}
        instance.post('user/token/refresh', refreshTokenData)
          .then(function (response) {
            appData.access_token = response.data.access_token;
            appData.refresh_token = response.data.refresh_token;
            appData = JSON.stringify(appData);
            localStorage.appData = appData;

            if(reqData){
              serviceInit();
              instance(reqData)
                .then(function (response) {
                  scallback(response);
                  loading('stop');
                })
                .catch(function (error) {
                  ecallback(error)
                  if(notif){
                    toast.error("متاسفانه عملیات با خطا مواجه شد !");
                  }
                  if(load){loading('stop')}
                });
            }
          })
          .catch(function (error) {
            redirectToLogin()
          });
      }else if(store.getState().routing.locationBeforeTransitions.pathname !== 'login'){
        redirectToLogin()
      }else{
        if(notif){
          toast.error("متاسفانه عملیات با خطا مواجه شد !");
        }
        if(load){loading('stop')}
        ecallback(err);
      }

    break;

    default:
      if(notif){
        toast.error("متاسفانه عملیات با خطا مواجه شد !");
      }
      if(load){loading('stop')}
      ecallback(err);
      break;
  }

}

export const postReq = (obj={}, url='', scallback=()=>{}, ecallback=()=>{}, notif=true, load=true) => {
    serviceInit()
    if(load){loading('start')}
    
    instance.post(url, obj)
      .then(function (response) {
        if(load){loading('stop')}
        scallback(response);
      })
      .catch(function (error) {
        const reqData = {
          method: 'post',
          url: url,
          data: obj
        }
        errorHandler(error, load, notif, scallback, ecallback, reqData);
      });
    return true;
}

export const uploadReq = (obj={}, url='', scallback=()=>{}, ecallback=()=>{}, notif=true, load=true) => {
    serviceInit()
    if(load){loading('start')}
    
    instance.post(url, obj)
      .then(function (response) {
        if(load){loading('stop')}
        scallback(response);
      })
      .catch(function (error) {
        const reqData = {
          method: 'post',
          url: url,
          data: obj
        }
        errorHandler(error, load, notif, scallback, ecallback, reqData);
      });
    return true;
}

export const getReq = (url='', scallback=()=>{}, ecallback=()=>{}, notif=true, load=true) => {
    serviceInit()
    if(load){loading('start')}
    
    instance.get(url)
      .then(function (response) {
        if(load){loading('stop')}
        scallback(response);
      })
      .catch(function (error) {
        const reqData = {
          method: 'get',
          url: url
        }
        errorHandler(error, load, notif, scallback, ecallback, reqData);
      });
    return true;
}

export const putReq = (obj={}, url='', scallback=()=>{}, ecallback=()=>{}, notif=true, load=true) => {
    serviceInit()
    if(load){loading('start')}

    instance.put(url, obj)
      .then(function (response) {
        if(load){loading('stop')}
        scallback(response);
      })
      .catch(function (error) {
        const reqData = {
          method: 'put',
          url: url,
          data: obj
        }
        errorHandler(error, load, notif, scallback, ecallback, reqData);
      });
    return true;
}

export const deleteReq = (url='', scallback=()=>{}, ecallback=()=>{}, notif=true, load=true) => {
    serviceInit()
    if(load){loading('start')}

    instance.delete(url)
      .then(function (response) {
        if(load){loading('stop')}
        scallback(response);
      })
      .catch(function (error) {
        const reqData = {
          method: 'delete',
          url: url
        }
        errorHandler(error, load, notif, scallback, ecallback, reqData);
      });
    return true;
}
